import {Injectable} from "@angular/core";
import {WrappedBehaviorSubject} from "../cache/wrapped-behavior-subject";

@Injectable({
    providedIn: 'root'
})
export class ProductCacheService {

    buyBoxSingleSelectedOptionSubject: WrappedBehaviorSubject<string> = new WrappedBehaviorSubject<string>();
    // Maps don't play nicely with WrappedBehaviorSubject storage behavior. pretend it's a Map.
    buyBoxMultipleSelectedOptionSubject: WrappedBehaviorSubject<Record<string, string>> = new WrappedBehaviorSubject<Record<string, string>>({});

    constructor() {
        // do nothing
    }

    get buyBoxSingleSelectedOption(): string {
        return this.buyBoxSingleSelectedOptionSubject.value;
    }

    set buyBoxSingleSelectedOption(value: string) {
        this.buyBoxSingleSelectedOptionSubject.next(value);
    }

    get buyBoxMultipleSelectedOptions(): Record<string, string> {
        return this.buyBoxMultipleSelectedOptionSubject.value || {};
    }

    getBuyBoxMultipleSelectedOption(usanaId: string): string {
        return this.buyBoxMultipleSelectedOptions[usanaId];
    }

    setBuyBoxMultipleSelectedOption(usanaId: string, value: string) {
        if (usanaId && value) {
            const currentMap = {...this.buyBoxMultipleSelectedOptions};
            currentMap[usanaId] = value;
            this.buyBoxMultipleSelectedOptionSubject.next(currentMap);
        }
    }
}
